import { ProductPaymentData } from '../application/product-payment-data.model';
import { TokenPayment } from '../conekta/token-payment.model';

export class CompletePaymentRequest {
  user: {
    username: string;
    name: string;
    lastName: string;
    email: string;
    phone: string;
    maxSigns: number,
    isTryAccount: boolean,
    isRecurrentPlan: boolean,
    isCompany: boolean,
    countryCode: number
  };
  tax: number;
  currency: string;
  products: ProductPaymentData[] = [];
  tokenConekta: TokenPayment;
  couponId: string;
  language: string;
  billing: {
    country: string;
    state: string;
    city: string;
    code: string;
    address: string;
    rfc: string;
    businessName: string;
  };
  card: {
    number: string;
    expMonth: number;
    expYear: number;
    cvc: number;
  };
  idSourceSystem: number;
}
